// @ts-check
/**
 * @typedef {import('./strategies/AdyenGooglePayStrategy').AdyenGooglePayStrategy} AdyenGooglePayStrategy
 * @typedef {import('./strategies/StripeGooglePayStrategy').StripeGooglePayStrategy} StripeGooglePayStrategy
 */

/**
 * GooglePay Payment Method
 * @function GooglePay
 */
const GooglePay = () => {
  /**
   * @type {AdyenGooglePayStrategy | StripeGooglePayStrategy | undefined}
   */
  let strategy;

  /**
   * Set the strategy
   * @param {AdyenGooglePayStrategy | StripeGooglePayStrategy} newStrategy
   * @returns {void}
   */
  const setStrategy = (newStrategy) => {
    strategy = newStrategy;
  };

  /**
   * Create a payload for Google Pay.
   * @param {Object} data - The Google Pay data from onSubmit callback.
   * @param {Object} [enginePayload] - Engine-specific payload (e.g. Stripe's
   *   `{ stripeConfirmationToken }`). Strategies that don't need it ignore it.
   * @returns {Promise<Object>} The payload.
   */
  const createPayload = (data, enginePayload = {}) => {
    if (!strategy) {
      throw new Error('Google Pay strategy not set');
    }

    return strategy.createPayload(data, enginePayload);
  };

  return {
    setStrategy,
    createPayload,
  };
};

const googlePay = GooglePay();

export default googlePay;
